<style>
	@import '@/assets/css/custom.css';
</style>

<template>
	<div>
		<Breadcrumbs main="Activation Request" title="New SIM Activation Request" />
 
		<div class="container-fluid">
			<div class="row">
				<div class="col-sm-12">
					
					<div class="card">
						<div class="card-body">

							<form @submit.prevent="downloadFile" enctype="multipart/form-data">
								<div class="form theme-form">
									<div class="row">
										<div class="col-md-3">
											<div class="mb-3">
												<label class="control-label">User Type<span class="text-danger">*</span></label>
												<select class="form-select" v-model="user_type">
													<option value="">Select User</option>
													<option value="1">Self</option>
												</select>
											</div>
										</div>

										<div class="col-md-3">
											<div class="mb-3">
												<label class="control-label">Action<span class="text-danger">*</span></label>
												<select class="form-select" v-model="action" @change="onActionChange">
													<option value="">Select Action</option>
													<option :value="action.id" v-for="action in actions" :key="action.id">
														{{action.action_name}}
													</option>
												</select>
											</div>
										</div>
									</div>

									<div class="row" v-if="action">
									
										<div class="col-md-3">
											<div class="mb-3">
												<label class="control-label">Project<span class="text-danger">*</span></label>
												<select class="form-select" v-model="project" @change="fetchProfile()">
													<option value="">Select Project</option>
													<option :value="project.id" v-for="project in projects" :key="project.id">
														{{project.project_name}}
													</option>
												</select>
											</div>
										</div>

										<div class="col-md-3">
											<div class="mb-3">
												<label class="control-label">Profile<span class="text-danger">*</span></label>
												<select class="form-select" v-model="profile">
													<option value="">Select Profile</option>
													<option :value="profile.id" v-for="profile in profiles" :key="profile.id">
														{{profile.profile_name}}
													</option>
												</select>
											</div>
										</div>

										<div class="col-md-3">
											<div class="mb-3">
												<label class="control-label">PO Number<span class="text-danger">*</span></label>
												<input class="form-control" type="text" placeholder="" v-model="po_number"/>
											</div>
										</div>

										<div class="col-md-3">
											<div class="mb-3">
												<label class="control-label">UTR Number<span class="text-danger">*</span></label>
												<input class="form-control" type="text" placeholder="" v-model="utr_number"/>
											</div>
										</div>

										<div class="col-md-3">
											<div class="mb-3">
												<label class="control-label">IP 1<span class="text-danger">*</span></label>
												<input class="form-control" type="text" placeholder="" v-model="ip_1"/>
											</div>
										</div>

										<div class="col-md-3">
											<div class="mb-3">
												<label class="control-label">IP 2<span class="text-danger">*</span></label>
												<input class="form-control" type="text" placeholder="" v-model="ip_2"/>
											</div>
										</div>

										<div class="col-md-3">
											<div class="mb-3">
												<label class="control-label">IP 3<span class="text-danger">*</span></label>
												<input class="form-control" type="text" placeholder="" v-model="ip_3"/>
											</div>
										</div>

										<div class="col-md-3">
											<div class="mb-3">
												<label class="control-label">IP 4<span class="text-danger">*</span></label>
												<input class="form-control" type="text" placeholder="" v-model="ip_4"/>
											</div>
										</div>

										<div class="col-md-3">
											<div class="mb-3">
												<label class="control-label">Mob No. 1<span class="text-danger">*</span></label>
												<input class="form-control" type="text" placeholder="" v-model="mn_1"/>
											</div>
										</div>

										<div class="col-md-3">
											<div class="mb-3">
												<label class="control-label">Mob No. 2<span class="text-danger">*</span></label>
												<input class="form-control" type="text" placeholder="" v-model="mn_2"/>
											</div>
										</div>

										<div class="col-md-3">
											<div class="mb-3">
												<label class="control-label">Mob No. 3<span class="text-danger">*</span></label>
												<input class="form-control" type="text" placeholder="" v-model="mn_3"/>
											</div>
										</div>

										<div class="col-md-3">
											<div class="mb-3">
												<label class="control-label">Mob No. 4<span class="text-danger">*</span></label>
												<input class="form-control" type="text" placeholder="" v-model="mn_4"/>
											</div>
										</div>
									
										<div class="col-md-3" v-if="[1, 2, 3, 6].includes(action)">
											<div class="mb-3">
												<label class="control-label">State<span class="text-danger">*</span></label>
												<select class="form-select" v-model="state">
													<option value="">Select State</option>
													<option :value="state.states" v-for="state in states" :key="state.id">
														{{state.states}}
													</option>
												</select>
											</div>
										</div>

										<div class="col-md-3">
											<div class="mb-3">
												<label class="control-label">Plan<span class="text-danger">*</span></label>
												<select class="form-select" v-model="plan">
													<option value="">Select Plan</option>
													<option :value="plan.plan_name" v-for="plan in plans" :key="plan.id">
														{{plan.plan_name}}
													</option>
												</select>
											</div>
										</div>
		
										<div class="col-md-3" v-if="[1, 2, 3, 6].includes(action)">
											<div class="mb-3">
												<label class="control-label">AIS 140 Backend<span class="text-danger">*</span></label>
												<select class="form-select" v-model="backend">
													<option value="">Select Backend</option>
													<option value="BSNL">BSNL</option>
													<option value="Others">Others</option>
												</select>
											</div>
										</div>
										
									</div>

									<div class="row ">
										<div class="col-sm-12">
											<!-- <button class="btn btn-warning me-2 float-end" type="submit">Download</button> -->
											<button type="submit" class="btn btn-warning me-2 float-end" v-if="!download.loading">Download</button>
											<img class="page-loader float-end" v-else src="@/assets/images/ajax-loader.gif"/>
										</div>
									</div>
	
								</div>
							</form>
		
						</div>
					</div>
				</div>
			</div>
		</div>

		<DynamicModal :title="modal_title">
			<template #body>
				<form @submit.prevent="" enctype="multipart/form-data">
					<div class="row mt-3">
						<div class="col-md-12 form-group">
							<!-- <label class="control-label">Logo </label> -->
							<input class="form-control" type="file" accept=".xls, .xlsx" />
						</div>
					</div>
					
					<div class="col-md-12 form-group mt-3">
						<button type="submit" class="btn btn-primary me-3" >{{ button_title }}</button>
						<button class="btn btn-light" @click="closeModal()">Close</button>
					</div>
				</form>
			</template>
		</DynamicModal>
	  
   </div>
</template>


<script>
import { onMounted } from 'vue'
import {Modal} from "bootstrap"
import DynamicModal from '@/components/dynamic_modal.vue'
	let dynamicmodal;

	export default {
		name: "Coupons eport",
		components: {
			DynamicModal
		},
		setup(){
			onMounted(() => {
				dynamicmodal = new Modal(document.getElementById('dynamicmodal'));
			})

			const showModal = () => {
				dynamicmodal.show();
			}

			const hideModal = () => {
				dynamicmodal.hide();
			}

			return {
				showModal, hideModal
			}
		},
		
		data() {

			const now = new Date()
			const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
			const today_str = new Date().toJSON().slice(0,10).replace(/-/g,'-')
			const minDate = new Date('2021-01-01') 
	      
			return {
				actions: [],
				projects: [],
				profiles: [],
				plans: [],
				states: [],
				pagination: {},
				start_date: '2021-01-01',
				end_date: today_str,
				
				min: minDate,
				max: today,
				keyword: "",
				listing_length: 10,
				token: "",
				i: 1,				

				modal_title: "Upload Excel",
				button_title: "Upload",

				user_type: 1,
				action: "",
				project: "",
				profile: "",
				state: '',
				plan: "",
				backend: '',
				mn_1: '',
				mn_2: '',
				mn_3: '',
				mn_4: '',
				ip_1: '',
				ip_2: '',
				ip_3: '',
				ip_4: '',

				errors: {},
				download: {
					loading: false,
				}

			};
		},
		mounted() {},

		created() {
			this.fetchAction();
			this.fetchStates();
		},

		methods: {

			getToken() {
				if (localStorage.getItem('trazio')) {
				var trazio =  JSON.parse(localStorage.getItem('trazio'));
				if(trazio.token) {

					this.token = trazio.token;
					this.user = trazio;
				} else {
					this.$swal("", "Failed to fetch token, please login again", "error");
					this.$router.push({ name: "login" });
				}

				} else {
				this.$swal("", "Session expired, please login again", "error");
				this.$router.push({ name: "login" });
				}
			}, 

			onActionChange() {
				this.fetchProject();
				this.fetchProfile();
				this.fetchPlan();
				this.project = "";
				this.profile = "";
			},

			fetchAction(page_url = null) {
				this.getToken();
				let url = "/trazio/getActions";
				page_url = page_url || url;
				this.active_page_url = page_url;
				this.$axios
					.get(page_url, { headers: { Authorization: "Bearer " + this.token } })
					.then((res) => {
						var responseData = res.data.data;
						console.log(responseData);
						this.actions = responseData.actions;

						// Reset project and profile
						this.project = "";
						this.projects = [];
						this.profile = "";
					})
					.catch((err) => console.log(err));
			},


			fetchProject(page_url = null) {
				if (!this.action) return;

				let url = "/trazio/getProjects?&action_id=" + this.action; 
				page_url = page_url || url;

				this.getToken();
				this.$axios
					.get(page_url, { headers: { Authorization: "Bearer " + this.token } })
					.then((res) => {
						var responseData = res.data.data;
						console.log(responseData);
						this.projects = responseData.projects;
					})
					.catch((err) => console.log(err));
			},

			fetchProfile(page_url = null) {
				this.profiles = [];
				this.profile = "";
				if (!this.project) return;

				let url = "/trazio/getProfiles?&project_id=" + this.project; 
				page_url = page_url || url;

				this.getToken();
				this.$axios
					.get(page_url, { headers: { Authorization: "Bearer " + this.token } })
					.then((res) => {
						var responseData = res.data.data;
						console.log(responseData);
						this.profiles = responseData.profiles;
					})
					.catch((err) => console.log(err));
			},

			fetchPlan(page_url = null) {
				if (!this.action) return;

				let url = "/trazio/getPlans?&action_id=" + this.action; 
				page_url = page_url || url;

				this.getToken();
				this.$axios
					.get(page_url, { headers: { Authorization: "Bearer " + this.token } })
					.then((res) => {
						var responseData = res.data.data;
						console.log(responseData);
						this.plans = responseData.plans;
					})
					.catch((err) => console.log(err));
			},

			fetchStates(page_url = null) {

				let url = "/trazio/getStates"; 
				page_url = page_url || url;

				this.getToken();
				this.$axios
					.get(page_url, { headers: { Authorization: "Bearer " + this.token } })
					.then((res) => {
						var responseData = res.data.data;
						console.log(responseData);
						this.states = responseData.states;
					})
					.catch((err) => console.log(err));
			},


			downloadFile() {
				this.getToken();
				this.download.loading = true;

				const formData = new FormData();
				formData.append("user_type", this.user_type);
				formData.append("action", this.action);
				formData.append("project", this.project);
				formData.append("profile", this.profile);
				formData.append("po_number", this.po_number);
				formData.append("utr_number", this.utr_number);
				formData.append("ip1", this.ip_1);
				formData.append("ip2", this.ip_2);
				formData.append("ip3", this.ip_3);
				formData.append("ip4", this.ip_4);
				formData.append("mobile_1", this.mn_1);
				formData.append("mobile_2", this.mn_2);
				formData.append("mobile_3", this.mn_3);
				formData.append("mobile_4", this.mn_4);
				formData.append("state", this.state);
				formData.append("plan", this.plan);
				formData.append("ais_140_backend", this.backend);

				const config = {
					headers: {
						"Content-Type": "multipart/form-data",
						"Accept": "application/json",
						"Authorization": "Bearer " + this.token
					},
					responseType: 'blob'
				};

				const url = "trazio/downloadSimActivation";

				this.$axios
					.post(url, formData, config)
					.then((response) => {
						const blob = new Blob([response.data], { type: response.headers['content-type'] });
						const link = document.createElement('a');
						link.href = URL.createObjectURL(blob);

						let fileName = 'sim_report.csv';
						const contentDisposition = response.headers['content-disposition'];
						if (contentDisposition) {
							const match = contentDisposition.match(/filename="?(.+)"?/);
							if (match && match.length > 1) {
								fileName = match[1];
							}
						}

						link.setAttribute('download', fileName);
						document.body.appendChild(link);
						link.click();
						document.body.removeChild(link);
						this.download.loading = false;

						this.clearForm();
						setTimeout(() => {
							this.$router.push({ name: 'view_activation' });
						}, 300);
						// this.$router.push({ name: 'view_activation' })
					})
					.catch(async (error) => {
						this.download.loading = false;
						if (error.response) {
							let responseData = error.response.data;

							// If responseType is 'blob', convert to JSON
							if (responseData instanceof Blob) {
								const text = await responseData.text();
								try {
									responseData = JSON.parse(text);
								} catch (e) {
									this.$swal("Error", "Failed to parse error response", "error");
									return;
								}
							}

							// 422 with object message
							if (error.response.status === 422 && typeof responseData.message === 'object') 
							{
								this.errors = responseData.message;
								const firstError = Object.values(responseData.message)[0][0] || "Validation error";
								this.$swal("Validation Error", firstError, "error");

							} // 422 with string message
							else if (error.response.status === 422 && typeof responseData.message === 'string') 
							{
								this.$swal("Error", responseData.message, "error");
							} // Other common errors
							else if (error.response.status === 401) 
							{
								this.$swal("Unauthorized", "Please login again", "error");
							} else if (error.response.status === 500) {
								this.$swal("Server Error", "Something went wrong on server", "error");
							} else {
								this.$swal("Error", "Unexpected error occurred", "error");
							}
						} else {
							this.$swal("Network Error", error.message, "error");
						}
					});

			},

			openModal() {
				this.showModal();
			},

			closeModal() {
				this.hideModal();
			},
            
			clearForm() {
				this.edit = false;
				this.action = "";
				this.project = "";
				this.profile = "";
				this.state = "";
				this.plan = "";
				this.backend = "";
				this.mn_1 = "";
				this.mn_2 = "";
				this.mn_3 = "";
				this.mn_4 = "";
				this.ip_1 = "";
				this.ip_2 = "";
				this.ip_3 = "";
				this.ip_4 = "";
				this.modal_title = "Upload Excel";
				this.button_title = "Upload";
				this.errors = {};
			},

		},
	};
</script>
